import { useEffect } from "react";

const DEFAULT_TITLE = "17C.COM - 最新电影电视剧资讯与在线播放平台";

interface PageMeta {
  title: string;
  description: string;
  keywords?: string;
}

function setMetaTag(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    setMetaTag("description", description);
    if (keywords) setMetaTag("keywords", keywords);

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, keywords]);
}